// extracted by mini-css-extract-plugin
export var logo = "_be-2";
export var logoWrapper = "_be-1";
export var strip = "_be-0";